export const disableBodyScroll = () => {
    const bodyEl = document.getElementsByTagName('body')[0];
    bodyEl.setAttribute('class', 'hideBodyScroll');
}

export const enableBodyScroll = () => {
    const bodyEl = document.getElementsByTagName('body')[0];
    bodyEl.removeAttribute('class');
}